import { render } from "./MdBadgeStandalone.vue?vue&type=template&id=2595c2d8"
import script from "./MdBadgeStandalone.vue?vue&type=script&lang=js"
export * from "./MdBadgeStandalone.vue?vue&type=script&lang=js"

import "./MdBadgeStandalone.vue?vue&type=style&index=0&id=2595c2d8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__